import { memo, useEffect, useState } from 'react';
import { BsChevronRight } from 'react-icons/bs';
import { Mousewheel, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
  detectUserSettingEnum,
  parseBuildProfile,
} from '../../../../common/parseProfileInfo';
import { IBuildProfileSwiper } from '../../../../interfaces/components/profileElement.interface';
import {
  RoleViewEnum,
  UserSettingEnum,
  UserSettingType,
} from '../../../../interfaces/profile.interface';

const MAX_FIELD = 10;

const BuildProfileSwiper: React.FC<IBuildProfileSwiper> = ({
  incompleteProfiles,
  currentSwiperSlide,
  setImageModal,
  setModal,
  roleView,
}) => {
  const [level, setLevel] = useState('');
  useEffect(() => {
    if (incompleteProfiles.length < 3) {
      setLevel('Chuyên Nghiệp');
      return;
    }
    if (incompleteProfiles.length < 8) {
      setLevel('Hoàn Thiện');
      return;
    }
    setLevel('Cơ Bản');
  }, [incompleteProfiles]);

  return (
    <div className="lg:rounded-lg lg:bg-white lg:py-10 lg:shadow-[0px_10px_20px_rgba(0,0,0,0.05)]">
      <div className="relative overflow-y-auto overflow-x-hidden">
        {roleView === RoleViewEnum.Owner && (
          <>
            <div className="px-5 lg:sticky lg:top-0 lg:z-10 lg:bg-white lg:pb-3">
              <div className="">
                <span className="">Hoàn thành hồ sơ level </span>
                <span className="text-primary">{level}</span>
                <span>
                  {' '}
                  - {`${MAX_FIELD - incompleteProfiles.length} / ${MAX_FIELD}`}
                </span>
              </div>

              <div className="mb-4 mt-3 flex h-2 w-full">
                {new Array(MAX_FIELD).fill(1).map((item, index) => {
                  return (
                    <div
                      key={`profile-progress-bar-${index + 1}`}
                      className={`h-1 w-full border ${
                        index < MAX_FIELD - incompleteProfiles.length
                          ? 'border-primary bg-primary'
                          : 'border-grey_1 bg-grey_1'
                      }`}
                    />
                  );
                })}
              </div>
            </div>

            {/* swiper: visible on mobile only */}
            <div id="slider" className="relative mb-8 py-2 lg:hidden">
              <Swiper
                initialSlide={currentSwiperSlide}
                onSlideChange={(swiper) => {
                  currentSwiperSlide = swiper.activeIndex;
                }}
                navigation={true}
                modules={[Mousewheel, Pagination, Navigation]}
                mousewheel={true}
                slidesPerView={1.3}
                centeredSlides={true}
                centeredSlidesBounds={true}
                spaceBetween={0}
                watchSlidesProgress={true}
              >
                <div id="slider-inner" className={`flex w-fit`}>
                  {incompleteProfiles.map((key: string) => {
                    const content = parseBuildProfile(key);

                    const userSettingName: UserSettingType | undefined =
                      detectUserSettingEnum(key);

                    return (
                      <SwiperSlide
                        className="lg:text-md cursor-pointer items-stretch text-[4vw]"
                        style={{
                          height: 'auto',
                        }}
                        onClick={() => {
                          if (userSettingName) {
                            if (userSettingName !== UserSettingEnum.Avatar)
                              setModal({
                                isOpen: true,
                                name: userSettingName,
                                value: null,
                              });
                            else setImageModal(true);
                          }
                        }}
                        key={`slider-profile-${key}`}
                      >
                        <div
                          key={`slider-profile-${key}`}
                          className={`mr-3 flex h-full flex-1 items-start 
                        justify-around rounded bg-[#F6F5FB] py-3`}
                        >
                          {content.icon}

                          <div className="h-full">
                            <p className="mb-5 text-[14px] font-semibold text-primary_black">
                              {content.title}
                            </p>
                            <p className="text-[10px] text-[#333333] ">
                              {content.description}{' '}
                            </p>
                          </div>

                          <div>
                            <BsChevronRight className="mx-4 mt-3 text-sm text-primary" />
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })}
                </div>
              </Swiper>
            </div>

            {/* cards: visible on desktop only */}
            <div className="hidden overflow-hidden px-5 md:text-base lg:block lg:max-h-[50dvh] lg:overflow-y-auto lg:text-xs">
              {incompleteProfiles.map((key: string) => {
                const content = parseBuildProfile(key);

                const userSettingName: UserSettingType | undefined =
                  detectUserSettingEnum(key);

                return (
                  <div
                    className="cursor-pointer p-[5px] transition-all hover:scale-110"
                    onClick={() => {
                      if (userSettingName) {
                        if (userSettingName !== UserSettingEnum.Avatar)
                          setModal({
                            isOpen: true,
                            name: userSettingName,
                            value: null,
                          });
                        else setImageModal(true);
                      }
                    }}
                    key={`slider-profile-${key}`}
                  >
                    <div
                      key={`slider-profile-${key}`}
                      className={`mr-3 flex h-full w-full flex-1 items-start 
                  rounded-lg bg-[#F6F5FB] py-3`}
                    >
                      <div className="max-w-5 p-0">{content.icon}</div>

                      <div className="flex h-full w-full justify-between">
                        <div className="h-full ">
                          <p className="mb- text-[14px] font-semibold text-primary_black">
                            {content.title}
                          </p>
                          <p className="text-[10px] text-[#333333] ">
                            {content.description}{' '}
                          </p>
                        </div>

                        <div>
                          <BsChevronRight className="mx-4 mt-3 text-sm text-primary" />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default memo(BuildProfileSwiper);
